import { render, staticRenderFns } from "./CompanyProgramMentorshipGroupsJourney.vue?vue&type=template&id=42506d56"
import script from "./CompanyProgramMentorshipGroupsJourney.vue?vue&type=script&lang=js"
export * from "./CompanyProgramMentorshipGroupsJourney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports